// DTO ⇄ form values for Update shipment — the only place its field names live.
import { formValue } from '@/lib/mappers/formValues';
import { FACILITY_KINDS, buildFacilityValue } from '@/config/formOptions';

// Every field the form owns; a missing key here would make its input uncontrolled.
export const EMPTY_UPDATE_SHIPMENT_FORM = Object.freeze({
  idPrefix: 'SP',
  idNumber: '',
  facilityId: '',
  terminalId: '',
  materialId: '',
  soldToId: '',
  shippingToId: '',
  shipmentQuantity: '',
  shipmentQuantityUnit: '',
  // Not a control — the shared form sets it; the order route takes the unit from the order instead.
  displayUnitId: '',
  dateOfDispatch: '',
  vesselName: '',
});

// One `pendingOrder(id)` node → the Update shipment form's inherited, locked field values.
export const processOrderForUpdateShipment = (order) => ({
  orderNo: order?.orderNo ?? '',
  // A back-to-back facility has no terminals, so the order can never have locked one for it.
  hasTerminal: Boolean(order?.terminalRefId),
  // A free-text terminal with no terminal record; the server keeps it, so the form shows it locked.
  legacyTerminal: order?.terminalRefId ? '' : (order?.terminal ?? ''),
  values: {
    ...EMPTY_UPDATE_SHIPMENT_FORM,
    facilityId: order?.site?.id
      ? buildFacilityValue(FACILITY_KINDS.site, order.site.id)
      : order?.backToBackAccountId
        ? buildFacilityValue(FACILITY_KINDS.backToBack, order.backToBackAccountId)
        : '',
    terminalId: formValue(order?.terminalRefId),
    materialId: formValue(order?.material?.id),
    soldToId: formValue(order?.customerAccount?.id),
    shippingToId: formValue(order?.shippingDetails?.id),
  },
});
